export const dashboardBarChartColors = {
    year2020: 'rgb(33, 150, 243)',
    year2021: 'rgb(23, 105, 170)',
    year2022: 'rgb(116, 178, 227)',
};

export const getColorByKey = (key): string => {
    return dashboardBarChartColors[key?.id] || '#000000';
};
